import { Link } from "react-router-dom";
import { ArrowRight, CalendarDays, DoorOpen, Receipt, Send } from "lucide-react";
import { Container, Eyebrow } from "@/components/shared/PageHeader";
import { Seo } from "@/components/shared/Seo";
import { Chat } from "@/components/assistant/Chat";

const CAN = [
  { icon: DoorOpen, t: "Rom og kapasitet", d: "Kva rom som passar til selskapet, møtet eller konserten din." },
  { icon: Receipt, t: "Prisar", d: "Rettleiande pris ut frå den offisielle prislista – for akkurat din bruk." },
  { icon: CalendarDays, t: "Ledige datoar", d: "Kva dagar som er heilt ledige, og kva som er oppteke (utan å røpe kven)." },
  { icon: Send, t: "Førespurnad", d: "Set opp ein uforpliktande bookingførespurnad som styret svarar på." },
];

export default function ChatPage() {
  return (
    <div data-testid="chat-page">
      <Seo title="Spør oss – rom, prisar og ledige datoar" description="Spør kulturhuset om rom, kapasitet, prisar og ledige datoar – svara kjem frå husets eigne data. Send ein uforpliktande førespurnad rett frå samtalen." path="/spor-oss" />
      <Container className="pb-12 pt-8 sm:pb-16 sm:pt-12 lg:pt-14">
        <div className="grid gap-8 lg:grid-cols-12 lg:gap-12">
          <aside className="lg:col-span-4">
            <Eyebrow>Spør oss</Eyebrow>
            <h1 className="t-h1 mt-4 text-balance" data-testid="page-title">Kva lurer du <em className="t-swash">på</em>?</h1>
            <p className="t-lead mt-5 max-w-md text-muted-foreground text-pretty">Svara kjem frå romma, prislista og kalenderen til kulturhuset – ikkje frå gjetting. Styret stadfestar alltid til slutt.</p>
            <ul className="mt-8 hidden divide-y divide-border border-y border-border lg:block">
              {CAN.map(({ icon: Icon, t, d }) => (
                <li key={t} className="flex gap-4 py-4">
                  <span className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-secondary text-foreground"><Icon className="h-4 w-4" /></span>
                  <span><p className="font-medium">{t}</p><p className="mt-1 text-[14.5px] leading-relaxed text-muted-foreground">{d}</p></span>
                </li>
              ))}
            </ul>
            <div className="mt-8 hidden flex-col items-start gap-3 lg:flex">
              <Link to="/leig-rom" className="inline-flex items-center gap-2 text-[15px] font-medium u-link" data-testid="chat-page-form-link">Vil du heller bruke skjemaet? <ArrowRight className="h-4 w-4" /></Link>
              <Link to="/kontakt" className="inline-flex items-center gap-2 text-[15px] font-medium u-link">Kontakt styret <ArrowRight className="h-4 w-4" /></Link>
            </div>
          </aside>
          <div className="lg:col-span-8">
            <div className="flex h-[min(760px,calc(100dvh-150px))] min-h-[560px] flex-col overflow-hidden rounded-[22px] bg-card shadow-soft ring-1 ring-foreground/10">
              <Chat active variant="page" />
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
}
